// returns query params object

export interface LinkProps {
  href: string;
  as: string;
}

// reverse order, url should be at the last in order, and first in api call
export const API_PARAM_ORDERS = ["postalCode", "engine", "numberOfProducts", "model", "make", "year", "url"];
// in same order
export const URL_PARAM_ORDERS = ["pageNumber", "make", "model", "year", "tier1", "tier2", "tier3", "prices", "manufacturers", "availabilities", "sizes"];

export function enocdeStr(str?: string): string {
  return str ? encodeURIComponent(str) : "";
}
